module.exports = __webpack_public_path__ + "img/orange.c8e8c910.png";